export function radioCustom() {

    let radioBlock = document.querySelectorAll('[data-radio]');

    radioBlock.forEach(function(item) {
        let radios = item.querySelectorAll('[am-radio]');

        radios.forEach(function(radio) {

            radio.addEventListener('click', function() {
                radios.forEach(function(elem) {
                    elem.classList.remove('is-active');
                });

                let input = radio.querySelector('input');

                if (input.checked) {
                    radio.classList.add('is-active');
                } else {
                    radio.classList.remove('is-active');
                }

            });
        });
    });

}
